import { BaseService } from "mrb/core";
import { ImpersonationApiRouteService } from "common/services";

class ImpersonationService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ImpersonationApiRouteService());
    }

    start(userId) {
        const url = this.routeService.start(userId);
        return this.apiClient.post(url, {});
    }
}

export default ImpersonationService;
